import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section 
        className="about-hero"
        style={{
          backgroundImage: `url('/images/dvi-hero.webp')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="about-hero-content">
          <h1>About Dvi Studios</h1>
          <p>Professional Photography Excellence in Hyderabad, India</p>
        </div>
      </section>

      {/* Main Content */}
      <div className="about-container">
        {/* Our Story Section */}
        <section className="about-section">
          <div className="about-content">
            <h2>Meet Dvi Studios</h2>
            <p>
              <strong>Dvi Studios</strong> is a premier photography studio based in Hyderabad, India, dedicated to capturing life's most precious moments with artistic excellence and professional expertise. 
              We specialize in creating stunning visual narratives that preserve your memories for a lifetime.
            </p>
            <p>
              Located in the heart of Hyderabad, India, our studio combines modern photography techniques with creative vision to deliver exceptional results. 
              From intimate portrait sessions to grand wedding celebrations, we approach every project with passion, attention to detail, and a commitment to excellence.
            </p>
            <p>
              Our team of experienced photographers brings together technical expertise and artistic flair to create images that not only document moments but tell compelling stories. 
              We believe that every photograph should evoke emotion and preserve the essence of the moment it captures.
            </p>
          </div>
          <div className="about-image">
            <img src="/images/1.webp" alt="Dvi Studios Photography" className="about-studio-image" />
          </div>
        </section>

        {/* Mission & Vision */}
        <section className="mission-vision">
          <div className="mission">
            <h3>Our Mission</h3>
            <p>
              To preserve the beauty of life's most precious moments through the lens of creativity, 
              technical excellence, and genuine care. We are dedicated to creating 
              wedding photographs, portrait photographs, and event photographs that don't just capture images, but preserve emotions, stories, and memories 
              that will be treasured for generations in Hyderabad, India and beyond.
            </p>
          </div>
          <div className="vision">
            <h3>Our Vision</h3>
            <p>
              To be Hyderabad's most trusted wedding photographer, event photographer, and portrait photographer, where every client feels 
              valued and every photograph tells a story worth remembering. We envision a future 
              where our legacy of photography excellence continues to grow, serving the Hyderabad community with the same 
              passion and dedication that defines our photography services.
            </p>
          </div>
        </section>

        {/* Legacy & Achievements */}
        <section className="legacy-section">
          <div className="legacy-content">
            <h2>A Legacy of Excellence & Community Pride</h2>
            <div className="legacy-grid">
              <div className="legacy-item">
                <div className="legacy-number">500+</div>
                <h3>Happy Clients</h3>
                <p>From intimate birthday party photography to grand wedding photography ceremonies, we've had the honor of capturing life's most precious moments with professional photography services.</p>
              </div>
              <div className="legacy-item">
                <div className="legacy-number">1000+</div>
                <h3>Events Captured</h3>
                <p>Our portfolio includes weddings, corporate events, birthday celebrations, and portrait sessions, each one crafted with attention to detail and artistic excellence.</p>
              </div>
              <div className="legacy-item">
                <div className="legacy-number">5★</div>
                <h3>Client Satisfaction</h3>
                <p>A testament to our commitment to quality, reliability, and the genuine care we show to every client who trusts us with their special moments.</p>
              </div>
            </div>
            <div className="pride-message">
              <blockquote>
                "In the heart of Hyderabad, India, where tradition meets modernity, we've been privileged to document the stories of our community through wedding photography, birthday photography, and portrait photography. 
                Every photograph we take carries the weight of trust that families have placed in our professional photography services. 
                This isn't just a photography business—it's our passion, our art, and our way of preserving the beautiful tapestry 
                of life in our beloved city of Hyderabad."
              </blockquote>
              <cite>- Dvi Studios Team, Professional Photographers</cite>
            </div>
          </div>
        </section>

        {/* Services Overview */}
        <section className="services-overview">
          <h2>What We Offer</h2>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">📸</div>
              <h3 style={{color: '#ffffff', fontWeight: '700', fontSize: '1.2rem', textShadow: '1px 1px 2px rgba(0,0,0,0.6)', fontFamily: 'Georgia, serif', fontStyle: 'italic'}}>Photography and Videography</h3>
              <p>Complete photography and videography services capturing every moment with professional quality and creative excellence.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">💒</div>
              <h3 style={{color: '#ffffff', fontWeight: '700', fontSize: '1.2rem', textShadow: '1px 1px 2px rgba(0,0,0,0.6)', fontFamily: 'Georgia, serif', fontStyle: 'italic'}}>Pre and Post Weddings</h3>
              <p>Beautiful pre-wedding and post-wedding photography sessions that tell your love story with artistic flair.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">👗</div>
              <h3 style={{color: '#ffffff', fontWeight: '700', fontSize: '1.2rem', textShadow: '1px 1px 2px rgba(0,0,0,0.6)', fontFamily: 'Georgia, serif', fontStyle: 'italic'}}>Fashion Shoots</h3>
              <p>Professional fashion photography that showcases style, elegance, and personality with stunning visual impact.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">🏢</div>
              <h3 style={{color: '#ffffff', fontWeight: '700', fontSize: '1.2rem', textShadow: '1px 1px 2px rgba(0,0,0,0.6)', fontFamily: 'Georgia, serif', fontStyle: 'italic'}}>Corporate Events</h3>
              <p>Professional event documentation for corporate gatherings, conferences, and business celebrations.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">👶</div>
              <h3 style={{color: '#ffffff', fontWeight: '700', fontSize: '1.2rem', textShadow: '1px 1px 2px rgba(0,0,0,0.6)', fontFamily: 'Georgia, serif', fontStyle: 'italic'}}>Baby Shoots</h3>
              <p>Adorable baby photography sessions capturing precious moments and milestones with gentle, loving care.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">📢</div>
              <h3 style={{color: '#ffffff', fontWeight: '700', fontSize: '1.2rem', textShadow: '1px 1px 2px rgba(0,0,0,0.6)', fontFamily: 'Georgia, serif', fontStyle: 'italic'}}>Ads</h3>
              <p>Creative advertising photography and videography that brings your brand to life with compelling visual stories.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">🎙️</div>
              <h3 style={{color: '#ffffff', fontWeight: '700', fontSize: '1.2rem', textShadow: '1px 1px 2px rgba(0,0,0,0.6)', fontFamily: 'Georgia, serif', fontStyle: 'italic'}}>Podcast</h3>
              <p>Professional podcast recording and production services with high-quality audio and video capabilities.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">🎬</div>
              <h3 style={{color: '#ffffff', fontWeight: '700', fontSize: '1.2rem', textShadow: '1px 1px 2px rgba(0,0,0,0.6)', fontFamily: 'Georgia, serif', fontStyle: 'italic'}}>Film Making</h3>
              <p>Complete film making services from concept to final production, creating cinematic masterpieces for any occasion.</p>
            </div>
          </div>
          
          {/* Serving Areas */}
          <div className="serving-areas" style={{textAlign: 'center', marginTop: '3rem', padding: '2rem', background: 'rgba(255, 255, 255, 0.05)', borderRadius: '15px', border: '1px solid rgba(255, 255, 255, 0.1)'}}>
            <h3 style={{color: '#ffffff', fontWeight: '700', fontSize: '1.5rem', textShadow: '1px 1px 2px rgba(0,0,0,0.6)', fontFamily: 'Georgia, serif', fontStyle: 'italic', marginBottom: '1rem'}}>Serving Areas</h3>
            <p style={{color: '#ffffff', fontSize: '1.1rem', fontWeight: '500', textShadow: '1px 1px 2px rgba(0,0,0,0.6)'}}>
              All over India, US, and UK
            </p>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="why-choose-us">
          <h2>Why Choose Dvi Studios?</h2>
          <div className="features-grid">
            <div className="feature">
              <div className="feature-icon">🏆</div>
              <h3>Professional Excellence</h3>
              <p>Years of experience capturing life's most important moments with unmatched expertise and passion.</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🏛️</div>
              <h3>Hyderabad's Trusted Name</h3>
              <p>A reputation built on trust, quality, and genuine care for the community we serve in Hyderabad.</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🎨</div>
              <h3>Creative Artistic Vision</h3>
              <p>Modern photography techniques combined with artistic flair to create timeless and memorable images.</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🤝</div>
              <h3>Personal Touch</h3>
              <p>Every client receives personalized attention and genuine care throughout their photography journey.</p>
            </div>
            <div className="feature">
              <div className="feature-icon">📍</div>
              <h3>Local Expertise</h3>
              <p>Deep understanding of Hyderabad's culture, traditions, and the perfect locations for your special moments.</p>
            </div>
            <div className="feature">
              <div className="feature-icon">📱</div>
              <h3>Modern Technology</h3>
              <p>Latest equipment and techniques combined with creative vision to deliver exceptional results every time.</p>
            </div>
          </div>
        </section>

        {/* Contact CTA */}
        <section className="contact-cta">
          <div className="cta-content">
            <h2>Ready to Create Timeless Memories?</h2>
            <p>Join hundreds of satisfied families who have trusted Dvi Studios with their most precious moments. Let's discuss your photography needs and create something beautiful together.</p>
            <div className="cta-buttons">
              <a href="/contact" className="btn btn-primary">Get In Touch</a>
              <a href="/portfolio" className="btn btn-secondary">View Our Work</a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
